import React from 'react'
import { Footer } from '../../../features/footer/footer'

function HomeLoggedIn() {
  return (
    <div>
      <Footer />
    </div>
  )
}

export default HomeLoggedIn
